import { Link } from '@chakra-ui/react';
import React from 'react';
import { ReactComponent as TwitchLiveProfileIcon } from '../../assets/icons/TwitchProfileLiveStream.svg';
import { getStreamUrl } from '../../service/games';
import { UserProfile } from '../../service/social';

interface LiveSocialLinksProps {
    profile: UserProfile;
}

/**
 * @param profile The user's profile. This component assumes that this profile has a linked Twitch account
 */
export const ProfileSocialLinks: React.FC<LiveSocialLinksProps> = ({ profile }) => {
    if (!profile.twitch_profile) {
        return <></>;
    }

    return (
        <Link
            className={'profile-social-link'}
            href={getStreamUrl(profile.twitch_profile?.login)}
            isExternal={true}
        >
            <TwitchLiveProfileIcon className={profile.twitch_stream ? 'live' : undefined} />
        </Link>
    );
};
